module.exports = __webpack_public_path__ + "media/images/athletes/3588-bb2dee4a7893db2add6029d01027c207.png";